import { __rest } from "tslib";
import * as React from 'react';
const Home = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M12.887 4.03a1.5 1.5 0 00-1.774 0l-6.5 4.767A1.5 1.5 0 004 10.007V18.5A1.5 1.5 0 005.5 20h13a1.5 1.5 0 001.5-1.5v-8.493a1.5 1.5 0 00-.613-1.21l-6.5-4.767zm-1.183.807a.5.5 0 01.592 0l6.5 4.766a.5.5 0 01.204.404V18.5a.5.5 0 01-.5.5H15v-4.5a1.5 1.5 0 00-1.5-1.5h-3A1.5 1.5 0 009 14.5V19H5.5a.5.5 0 01-.5-.5v-8.493a.5.5 0 01.204-.404l6.5-4.766zM10 19h4v-4.5a.5.5 0 00-.5-.5h-3a.5.5 0 00-.5.5V19z" })));
};
Home.displayName = 'Home';
export default Home;
//# sourceMappingURL=Home.js.map